import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, CalendarPlus } from "lucide-react";
import { Logo } from "./Logo";

const links = [
 { to: "/", label: "Home" },
 { to: "/about", label: "About" },
 { to: "/services", label: "Services" },
 { to: "/how-it-works", label: "How it Works" },
 { to: "/telehealth", label: "Telehealth" },
 { to: "/insurance", label: "Insurance" },
 { to: "/resources", label: "Resources" },
 { to: "/faq", label: "FAQ" },
 { to: "/contact", label: "Contact" },
];

export default function Navbar() {
 const [open, setOpen] = useState(false);
 const [scrolled, setScrolled] = useState(false);
 const loc = useLocation();

 useEffect(() => {
 const onScroll = () => setScrolled(window.scrollY > 8);
 onScroll();
 window.addEventListener("scroll", onScroll);
 return () => window.removeEventListener("scroll", onScroll);
 }, []);

 useEffect(() => { setOpen(false); }, [loc.pathname]);

 return (
 <header
 data-testid="site-navbar"
 className={`sticky top-0 z-50 transition-all duration-300 ${scrolled ? "glass border-b border-[#E8EBE4]" : "bg-transparent"}`}
 >
 <nav className="container-pad max-w-7xl mx-auto flex items-center justify-between h-[112px] sm:h-[128px]">
 <Logo size="2xl" />
 <div className="hidden xl:flex items-center gap-6">
 {links.map((l) => (
 <NavLink
 key={l.to}
 to={l.to}
 data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
 className={({ isActive }) =>
 `text-[13px] font-bold link-underline ${isActive ? "text-forest-700" : "text-ink/80 hover:text-ink"}`
 }
 >
 {l.label}
 </NavLink>
 ))}
 </div>
 <div className="hidden xl:flex items-center gap-3">
 <Link to="/contact" data-testid="nav-book-cta" className="inline-flex items-center justify-center gap-2 rounded-full bg-gold-500 hover:bg-gold-600 text-forest-800 font-semibold text-[13px] px-5 py-2.5 transition-all duration-300 ease-out active:scale-95">
 <CalendarPlus className="w-4 h-4" strokeWidth={1.75} />
 Book appointment
 </Link>
 </div>
 <button
 onClick={() => setOpen((o) => !o)}
 data-testid="nav-mobile-toggle"
 aria-label="Toggle navigation"
 className="xl:hidden inline-flex items-center justify-center w-11 h-11 rounded-full border border-[#E2E8F0] bg-paper"
 >
 {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
 </button>
 </nav>

 {open && (
 <div className="xl:hidden border-t border-[#E8EBE4] bg-cream/95 backdrop-blur-md">
 <div className="container-pad max-w-7xl mx-auto py-6 flex flex-col gap-2">
 {links.map((l) => (
 <NavLink
 key={l.to}
 to={l.to}
 data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
 className={({ isActive }) =>
 `px-4 py-3 rounded-xl text-base ${isActive ? "bg-sage-50 text-sage-800" : "text-ink/80 hover:bg-sage-50"}`
 }
 >
 {l.label}
 </NavLink>
 ))}
 <Link to="/contact" data-testid="mobile-book-cta" className="btn-gold mt-3 self-start">
 <CalendarPlus className="w-4 h-4" /> Book appointment
 </Link>
 </div>
 </div>
 )}
 </header>
 );
}
